/**
 * Utility functions for auth token management
 */

/**
 * Calculate the expiry timestamp from TTL in seconds
 *
 * @param {number} ttl - Time to live in seconds
 * @returns {number} Expiry timestamp in milliseconds
 */
export const calculateExpiryFromTTL = (ttl: number): number => {
    return Date.now() + (ttl * 1000);
}

/**
 * Calculate milliseconds remaining until token expiry
 *
 * @param {number | null} expiresAt - Expiry timestamp in milliseconds
 * @returns {number} Milliseconds until expiry (0 if already expired or null)
 */
export const calculateMsUntilExpiry = (expiresAt: number): number => {
    return Math.max(0, expiresAt - Date.now());
}

/**
 * Check if the token is expired
 *
 * @param {number | null} expiresAt - Expiry timestamp in milliseconds
 * @returns {boolean} True if token is expired
 */
export const isTokenExpired = (expiresAt: number | null): boolean => {
    if(!expiresAt) return false;

    return Date.now() >= expiresAt;
}

/**
 * Check if the token is expiring soon (within minutes)
 *
 * @param {number | null} expiresAt - Expiry timestamp in milliseconds
 * @param {number} minutes - Minimum time in minutes before token expires (default: 5)
 *
 * @returns {boolean} True if token expires in the given timeframe
 */
export const isTokenExpiringSoon = (expiresAt: number | null, minutes: number = 5): boolean => {
    if(!expiresAt) return false;

    const time  = minutes * 60 * 1000;

    return Date.now() >= (expiresAt - time);
}
